export default __webpack_public_path__ + "835d9ed4a34a9c3c8e0edd08eda825cc.glb";